export const URL_TYPE_LABELS: Record<string, string> = {
  discussion: "Discussion",
  reference: "Reference",
  directory: "Directory",
  alternative: "Alternatives",
  comparison: "Comparison",
  listicle: "Listicle",
  how_to: "How-To Guide",
  product: "Product Page",
  news: "News",
  other: "Other",
};

export const URL_TYPE_OPTIONS = [
  { value: "all", label: "All Types" },
  ...Object.entries(URL_TYPE_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

export const DOMAIN_TYPE_OPTIONS = [
  { value: "all", label: "All Types" },
  { value: "Publisher", label: "Publisher" },
  { value: "Competitor", label: "Competitor" },
  { value: "Community", label: "Community" },
  { value: "Owned", label: "Owned" },
  { value: "Other", label: "Other" },
] as const;

const URL_TYPE_ALIASES: Record<string, string> = {
  list: "listicle",
  lists: "listicle",
  listicles: "listicle",
  howto: "how_to",
  "how to": "how_to",
  "how-to": "how_to",
  "how to guide": "how_to",
  "how-to guide": "how_to",
  "product page": "product",
  "product pages": "product",
  "product_page": "product",
  "product-page": "product",
  productpage: "product",
  alternatives: "alternative",
  comparisons: "comparison",
  directories: "directory",
  directory_listing: "directory",
  "directory-listing": "directory",
  forum: "discussion",
  thread: "discussion",
};

export const normalizeUrlTypeValue = (value?: string | null): string => {
  const normalized = String(value || "").trim().toLowerCase();
  if (URL_TYPE_LABELS[normalized]) {
    return normalized;
  }
  const alias = URL_TYPE_ALIASES[normalized];
  if (alias) {
    return alias;
  }
  const labelMatch = Object.entries(URL_TYPE_LABELS).find(
    ([, label]) => label.toLowerCase() === normalized,
  );
  return labelMatch?.[0] ?? "other";
};

export const toUrlTypeLabel = (value?: string | null): string =>
  URL_TYPE_LABELS[normalizeUrlTypeValue(value)];

export const getUrlTypeBadgeClassName = (value?: string | null): string => {
  const normalized = normalizeUrlTypeValue(value);
  const baseClassName =
    "inline-flex h-[22px] items-center justify-center rounded-[6px] border px-[10px] py-[2px] text-xs leading-none";

  const paletteByType: Record<string, string> = {
    listicle: "border-[#3B82F6] text-[#3B82F6]",
    alternative: "border-[#D946EF] text-[#D946EF]",
    comparison: "border-[#14B8A6] text-[#14B8A6]",
    directory: "border-[#F59E0B] text-[#F59E0B]",
    discussion: "border-[#EC4899] text-[#EC4899]",
    how_to: "border-[#0EA5E9] text-[#0EA5E9]",
    product: "border-[#6E56CF] text-[#6E56CF]",
    reference: "border-[#65A30D] text-[#65A30D]",
    news: "border-[#6366F1] text-[#6366F1]",
    other: "border-[#E5E5E5] text-[#0A0A0A]",
  };

  return `${baseClassName} ${paletteByType[normalized] || paletteByType.other}`;
};

export const getDomainTypeBadgeClassName = (value?: string | null): string => {
  const normalized = String(value || "").trim();
  const baseClassName =
    "inline-flex h-[22px] items-center justify-center rounded-[6px] border px-[10px] py-[2px] text-xs leading-none";

  const paletteByType: Record<string, string> = {
    Competitor: "border-[#6E56CF] text-[#6E56CF]",
    Owned: "border-[#FF5E00] text-[#FF5E00]",
    Publisher: "border-[#3DB9CF] text-[#3DB9CF]",
    Community: "border-[#FFC53D] text-[#FFC53D]",
    Other: "border-[#E5E5E5] text-[#0A0A0A]",
  };

  return `${baseClassName} ${paletteByType[normalized] || paletteByType.Other}`;
};
